import { render, staticRenderFns } from "./prescriptionItemEditor.vue?vue&type=template&id=a552a696&scoped=true&"
import script from "./prescriptionItemEditor.vue?vue&type=script&lang=js&"
export * from "./prescriptionItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./prescriptionItemEditor.vue?vue&type=style&index=0&id=a552a696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a552a696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a552a696')) {
      api.createRecord('a552a696', component.options)
    } else {
      api.reload('a552a696', component.options)
    }
    module.hot.accept("./prescriptionItemEditor.vue?vue&type=template&id=a552a696&scoped=true&", function () {
      api.rerender('a552a696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/components/prescriptionItemEditor.vue"
export default component.exports